import { render, staticRenderFns } from "./infoMenu.vue?vue&type=template&id=498d131c&scoped=true&"
import script from "./infoMenu.vue?vue&type=script&lang=js&"
export * from "./infoMenu.vue?vue&type=script&lang=js&"
import style0 from "./infoMenu.vue?vue&type=style&index=0&id=498d131c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498d131c",
  null
  
)

export default component.exports